import config from 'config';

export default {
  index: `/`,
  portal: `${config.rootPath}`,
  dashboard: `${config.rootPath}/dashboard`,
  appointments: `${config.rootPath}/appointments`,
  messages: `${config.rootPath}/messages`,
  profile: `${config.rootPath}/profile`,
  passwordRecovery: `${config.rootPath}/accounts/reset-password`,
  passwordReset: `${config.rootPath}/accounts/claim`,
  accountActivation: `${config.rootPath}/accounts/claim-patient`,
  login: `${config.rootPath}/login`,
  unauthenticatedBooking: `${config.rootPath}/booking`,
  unauthenticatedBookingThankYou: `${config.rootPath}/booking-thank-you`,
  videoSession: `${config.rootPath}/video-session`,
  settings: `${config.rootPath}/settings`,
  account: `${config.rootPath}/settings/account`,
  sessionAccess: `${config.rootPath}/direct/appointments`,
  payment: `${config.rootPath}/settings/payment`,
  termsandcondition: `${config.rootPath}/terms-and-condition`,
  invoices: `${config.rootPath}/invoices`,
};
